<div class="row">
  <div class="col-lg-6">
    <spe-alert [class]="apiStatus" [message]="message"></spe-alert>
  </div>
</div>

<div class="row" *ngIf="showStepOne">
  <div class="col-lg-6">
  <spe-titulo-sessao icone="assets/icones/cinza/upload.svg" titulo="Upload"></spe-titulo-sessao>

    <form [formGroup]="filesDataForm">
      <input type="file" class="form-control mb-3" accept=".txt" (change)="onChangeFile($event)">
    
      <div class="d-flex justify-content-between align-items-center">
        <small>Apenas arquivos .txt são permitidos</small>
        <button mat-flat-button (click)="openImportDialog()" [disabled]="!filesDataForm.valid">Importar arquivo</button>
      </div>
    </form>
  </div>
</div>

<!-- fase de carregamento do arquivo -->
<div class="row justify-content-center mt-48" *ngIf="showStepTwo">
  <div class="col-lg-6">

    <div class="text-center">
      <div class="spinner-border color-brand-principal mb-16" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>

      <h2 class="mb-8">{{ alertTitle }}</h2>
      <p>{{ alertMessage }}</p>
    </div>

    <div *ngIf="showStepCounters" class="background rounded-16 p-4">
      <div><b>Funcionários:</b>&nbsp;&nbsp;{{ employees }}</div>
      <div><b>Benefícios:</b>&nbsp;&nbsp;{{ benefits }}</div>
      <div><b>Erros:</b>&nbsp;&nbsp;{{ errors }}</div>
    </div>

  </div>
</div>

<!-- caso tenha sucesso -->
<div class="d-flex vstack align-items-center text-center mt-48" *ngIf="showStepSuccess">
  <div class="background rounded-circle p-4 mb-24">
    <img src="assets/icones/cinza/ok_icon.svg" alt="" width="80">
  </div>

  <h2 class="mb-8">{{ alertTitle }}</h2>
  <p>{{ alertMessage }}</p>

  <div class="mt-8">
    <button mat-flat-button (click)="importResume()" class="me-2">Resumo da importação</button>
    <button mat-stroked-button (click)="novaImportacao()">Importar novo arquivo</button>
  </div>
</div>


<!-- caso tenha inconsistencia no arquivo -->
<div class="row mt-48 justify-content-center" *ngIf="showStepError">
  <div class="col-lg-6">

    <h2 class="mb-8 text-center">Verificação de dados</h2>
    <!-- alerta -->
    <spe-alert [class]="alertStatus" [message]="alertMessage"></spe-alert>

    <div class="text-center mt-16">
      <button mat-flat-button (click)="goTo()">Verificar dados</button>
      <p class="font-size-14 mt-16">
        Caso tenha dúvidas entre em contato com a
        <a href="mailto:atendimento.beneficios@semparar.com.br?subject=Dúvidas - Importação de dados dados APB (arquivo padrão de benefícios)">
          central de atendimento
        </a>
      </p>
    </div>

  </div>
</div>

<!-- caso falhe na importação -->
<div class="row mt-48 justify-content-center" *ngIf="showStepFail">
  <div class="col-lg-6">
    <h2 class="text-center">Falha na importação</h2>
    <div class="alert alert-warning">
      <b>Atenção!</b>
      <div>Por algum motivo não foi possível concluir a importação. Por gentileza tente novamente.</div>
    </div>
    <p class="font-size-14 mt-16 text-center">
      Caso o erro persista em contato com a
      <a href="mailto:atendimento.beneficios@semparar.com.br?subject=Dúvidas - Importação de dados dados APB (arquivo padrão de benefícios)">
        central de atendimento
      </a>
    </p>
  </div>
</div>

<!-- alerta -->
<div class="row mt-48 justify-content-center" *ngIf="showStepAlert">
  <div class="col-lg-6">
    <spe-alert [class]="alertStatus" [message]="alertMessage"></spe-alert>
    <div class="alert alert-warning" *ngFor="let element of errorsToShow">
      <div>{{ element }}</div>
    </div>
    <p class="font-size-14 mt-16 text-center">
      Caso tenha dúvidas entre em contato com a
      <a href="mailto:atendimento.beneficios@semparar.com.br?subject=Dúvidas - Importação de dados dados APB (arquivo padrão de benefícios)">
        central de atendimento
      </a>
    </p>
  </div>
</div>